import { render, staticRenderFns } from "./SectionHeroHome.vue?vue&type=template&id=353f38d2&scoped=true"
import script from "./SectionHeroHome.vue?vue&type=script&lang=js"
export * from "./SectionHeroHome.vue?vue&type=script&lang=js"
import style0 from "./SectionHeroHome.vue?vue&type=style&index=0&id=353f38d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353f38d2",
  null
  
)

export default component.exports